import Navbar from "../components/NavBar";
// import MusicBanner from "../components/MusicBanner";
import MusicContent from "../components/MusicContent";
import Footer from "../components/Footer";


const Music = () => {


  return (
    <div className="">
      <Navbar />
        {/* <MusicBanner /> */}
        <div className="App-header">
          <div className="container-md">
            <MusicContent />
          </div>
        </div>
      <Footer />
    </div>
  );
};

export default Music;
